export const setStorage = (key: string, value: any) => localStorage.setItem(key, JSON.stringify(value));
export const getStorage = (key: string) => {
  if (typeof window === 'undefined') return 'null';
  return JSON.parse(localStorage.getItem(key) || 'null');
};
